import { inject, Injectable } from '@angular/core';
import { CustomerAccount, CustomerService } from '@garmin-avcloud/avcloud-web-utils';
import { Observable, of } from 'rxjs';

import { tap } from 'rxjs/operators';
@Injectable()
export class CustomersServiceWithCache {
  private readonly customerService = inject(CustomerService);
  private readonly customersCache: Map<string, Observable<CustomerAccount | null>> = new Map();

  getAndCacheCustomer(customerGuid: string): Observable<CustomerAccount | null> {
    let customerToReturn = this.customersCache.get(customerGuid);
    if (customerToReturn == null) {
      customerToReturn = this.customerService.getCustomerAccount(customerGuid).pipe(
        tap((customer) => {
          this.customersCache.set(customerGuid, of(customer));
        })
      );
    }
    return customerToReturn;
  }
}
